<template>
  <!--询盘服务-->
  <div class="ab-iserver">
    <div class="ab-iserver-header flex-row">
      <div class="ab-banner-header flex-col">
        <MainNav />
        <div class="ab-banner-info warp">
          <div class="ab-banner-name fontsize50" data-aos="fade-down">
            让出海营销更经济、简单、高效
          </div>
          <div
            class="ab-banner-desc fontsize20"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            依托强大的自主创新研发能力与多元化外贸场景应用，专注于全链路数字化营销解决方案，以询盘达标量作为服务质量的衡量指标，有效降低企业用户渠道推广及营销成本，快速激活潜客，赋能外贸精准化营销
          </div>
          <div class="ab-banner-btn" data-aos="fade-down" data-aos-delay="200">
            <Abbutton
              ><a
                @click="showModal"
                data-source="p"
                onmouseover="linkDataSource(this)"
                a-type="register"
                target="_blank"
                >立即试用</a
              ></Abbutton
            >
          </div>
        </div>
      </div>
    </div>
    <div class="iserver-product-features">
      <div class="warp">
        <AbBlock title="产品特点" subTitle="更便捷的自动化营销平台">
          <div class="features-list">
            <Features :dataList="featsList" />
          </div>
        </AbBlock>
      </div>
    </div>

    <!--优势对比-->
    <!-- <Competitive></Competitive> -->
    <Competitive :dataList="competitiveData"></Competitive>
    <!--服务列表价格清单-->
    <ServerList></ServerList>
    <!--问题列表-->
    <!-- <QuestionList></QuestionList> -->
    <QuestionList v-bind="questionData"></QuestionList>
    <!--已服务列表-->
    <CustomerList></CustomerList>

    <FooterBanner></FooterBanner>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import MainNav from "@/components/MainNav.vue";
import Abbutton from "@/components/Abbutton.vue";
import AbBlock from "@/components/AbBlock.vue";
import Features from "@/components/Features.vue";
import Competitive from "@/components/Competitive.vue";
import ServerList from "./Iserver/ServerList.vue";
import QuestionList from "@/components/QuestionList.vue";
import CustomerList from "@/components/CustomerList.vue";
import FooterBanner from "@/components/FooterBanner.vue";
import metaInfo from "@/metaInfo";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import { usePageTracker } from "@/utils/pageTracker";
export default {
  metaInfo: metaInfo["iserver"],
  components: {
    MainNav,
    Abbutton,
    Features,
    Competitive,
    ServerList,
    QuestionList,
    CustomerList,
    AbBlock,
    FooterBanner,
    inquiryModalVue,
  },
  data() {
    return {
      visible: false,
      featsList: [
        {
          id: "1",
          title: "询盘数量有保障",
          desc:
            "线索培育自动化推送，全网捕捉商机保底增量，高效稳定且服务有保障，仅以询盘达标量作为衡量服务指标，快速沉淀潜在用户，积极拓展海外市场客户。",
          icon_url: "icon_询盘数量有保障.png",
        },
        {
          id: "2",
          title: "简化交互流程",
          desc:
            "基于核心技术自主创新研发与运营，简化场景交互流程，避免冗杂的审核规则及流程，出海企业无需配备专业的运营团队，省心省力安心做甩手掌柜。",
          icon_url: "icon_简化交互流程.png",
        },
        {
          id: "3",
          title: "量化效果更明显",
          desc:
            "通过模型智能唤醒孵化潜客，实时监测其向客户生命周期更深层次转化，通过各项关键指标精准量化日常运营效果，让服务过程更直观可见。",
          icon_url: "icon_量化效果更明显.png",
        },
        {
          id: "4",
          title: "销售赋能工具",
          desc:
            "全链路数字化营销模式，智能推荐与过滤询盘，应用大数据深度挖掘用户需求，打破销售墨守成规的销售模式，降低销售预判与客户成交成本。",
          icon_url: "icon_销售赋能工具.png",
        },
        {
          id: "5",
          title: "多套应用集于一体",
          desc:
            "基于SaaS产品生态化建设，聚合多套应用，满足不同行业细分客户应用需求，通过海量数据计算推荐企业匹配客户，有效降低企业试错及学习成本。",
          icon_url: "icon_多套应用集于一体.png",
        },
        {
          id: "6",
          title: "全域数字营销",
          desc:
            "聚焦全球搜索引擎及海外社交媒体全渠道覆盖，帮助企业打造品牌构建私域流量，让流量成留量，快速获得商机，利用口碑营销深度融入目标市场。",
          icon_url: "icon_全域数字营销.png",
        },
      ],
      questionData: {
        blockTitle: "常见问题",
        blockSubTitle: "帮助客户快速解决问题",
        listData: [
          {
            q: "询盘服务的询盘数量是如何保障的？",
            a:
              "不同的询盘服务套餐所包含的询盘保底量不同，企业客户客根据实际需求选择对应的版本服务，因产品属性和行业不同，所获得的首个询盘时间不同，一般以获得第一个询盘时间为起始时间，直至承诺的询盘数量达标为止。",
          },
          {
            q: "询盘服务是如何收取费用的？",
            a:
              "询盘服务收费的模式是采用合同周期制的模式进行计费的，不同的套餐版本所包含的专属询盘数量不同，其目的是为企业客户获取指定的询盘量为指标，若询盘数量达到指定的标准，则询盘服务将终止服务。",
          },
          {
            q: "询盘的质量如何保障的？",
            a:
              "询盘服务中的询盘质量不会因为数量的提高而降低询盘的质量，而产生的每一个询盘都是经过NLP技术+人工校验双重筛选后，才会自动推送至客户账户；询盘服务中的询盘数量的多少是由技术和服务指标所决定的，不是以垃圾询盘而进行充数的。",
          },
          {
            q: "服务期限届满后，如何进行续费的？",
            a:
              "询盘服务是以合同周期制模式进行服务的，为保障企业用户的相关权益，服务期届满后，续费时将会另外签署新的合同协议，若期间企业客户发起退款申请，则相关服务及指标按进度进行折算后退款。",
          },
        ],
      },
      competitiveData: {
        title: "区别于市面其他产品",
        subTitle: "营销指标更容易把控",
        data: [
          {
            title: "跨境电商平台",
            features: [
              "入驻平台审核机制复杂，产品单一化",
              "恶性竞争严重，平台推广费用高",
              "实现品牌溢价难，需雇专业运营团队",
              "推送大量重复性广告询盘且不精准",
            ],
          },
          {
            title: "AB客询盘服务",
            features: [
              "流程简化，一套应用包含多个平台",
              "套餐价格透明，避免恶性投放竞争",
              "容易塑造品牌形象，全程托管式运营",
              "人工+智能双重筛选过滤，精准有效",
            ],
          },
        ],
      },
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass">
.ab-iserver .ab-question .q-list .q-item .q-block{
height:7rem
}
.ab-iserver-header {
  height:620px;
  background: url('~@/assets/images/询盘服务_banner.jpg')
    100% no-repeat;
  width: 100%;
  background-size:cover;
}

.ab-iserver .ab-banner-header {
  width: 100%;
  height: 100%;

  .ab-banner-info{
    padding-top:74px;
    padding-left:145px;
    .ab-banner-name{

      height: 69px;
      font-family: AlibabaPuHuiTiM;
      color: #333646;
      line-height: 69px;
    }

    .ab-banner-desc{
      width: 549px;
      margin-bottom:45px;
      font-family: Alibaba-PuHuiTi-R;
      font-weight: normal;
      color: rgba(51,51,51,0.4);
      line-height: 36px;
      padding-top: 27px;
    }
    .ab-banner-btn{
      width:200px;
    }
  }
}

.iserver-product-features{
  padding-top: 55px;
  padding-bottom: 164px;
  .features-list{
    padding-top: 62px;
  }
}
</style>
